export enum StudySetComponentType {
  Book = 'book',
  Exercise = 'exercise',
  SpeakingChallenge = 'speaking-challenge',
  Video = 'video'
}
